import React from 'react';
import { makeStyles } from '@mui/styles';
import { Avatar, Box, Typography, Popover, Divider, Link } from '@mui/material';

import PopoverStyles from '../../../components/styles/popover';
import palette from '../../../components/styles/palette';

const useStyles = makeStyles(({ typography }) => ({
  container: {
    width: typography.pxToRem(260),
  },
  header: {
    paddingTop: typography.pxToRem(15),
    paddingBottom: typography.pxToRem(15),
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
  },
  userDetails: {
    marginTop: typography.pxToRem(5),
  },
  username: {
    textAlign: 'center',
    fontSize: typography.pxToRem(14),
    lineHeight: typography.pxToRem(20),
  },
  email: {
    textAlign: 'center',
    color: palette.typography.black.medium,
    fontSize: typography.pxToRem(11),
    lineHeight: typography.pxToRem(14),
  },
  body: {
    paddingTop: typography.pxToRem(15),
    paddingBottom: typography.pxToRem(15),
    paddingLeft: typography.pxToRem(20),
    paddingRight: typography.pxToRem(20),
  },
  footer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: typography.pxToRem(66),
  },
  divider: {
    background: '#E6E7E8',
  },
  avatar: {
    width: typography.pxToRem(50),
    height: typography.pxToRem(50),
  },
  link: {
    fontSize: typography.pxToRem(14),
    lineHeight: typography.pxToRem(26),
  },
  button: {
    textTransform: 'none',
  },
}));

const AppMenu = ({
  photo,
  email,
  username,
  open,
  setOpen,
  anchorEl,
  onSelectMenuItem,
  menuItems,
}) => {
  const styles = useStyles();

  return (
    <Popover
      onClose={() => setOpen(!open)}
      open={open}
      anchorEl={anchorEl}
      {...PopoverStyles}
    >
      <Box className={styles.container}>
        <Box className={styles.header}>
          <Avatar className={styles.avatar} alt="User photo" src={photo} />
          <Box className={styles.userDetails}>
            <Typography className={styles.username}>{username}</Typography>
            <Typography className={styles.email}>{email}</Typography>
          </Box>
        </Box>
        <Divider className={styles.divider} />
        <Box className={styles.body}>
          {menuItems.map(({ title, link }, id) => (
            <Link
              key={`${title}_${id}`}
              target="_blank"
              href={link}
              onClick={() => onSelectMenuItem && onSelectMenuItem(title)}
            >
              <Typography className={styles.link}>{title}</Typography>
            </Link>
          ))}
        </Box>
        <Divider className={styles.divider} />
      </Box>
    </Popover>
  );
};

export default AppMenu;
